<div class="login-wrapper login">
    <div class="login-inner">
        <p class="voilet-text fw-900 f-26 text-center">Login / Register</p>        
        <div class="w90 m-auto mt-30">            
            <form [formGroup]="form" class="example-form">
                <div *ngIf="!sendotp">
                    <p class="f-16 regularfont greyfont">Enter your email/mobile no.</p>
                    <mat-form-field class="example-full-width" appearance="outline" class="w100">
                        <!-- <input maxlength="10" required matInput formControlName="mobileOrEmail" 
                         (focusout)="onFocusOutEvent($event)" autocomplete="off" style="text-align: left;" appOnlyNumbers>-->
                         <input  required matInput formControlName="mobileOrEmail" (focusout)="onFocusOutEvent($event)"
                          autocomplete="off" style="text-align: left;" >   
                      </mat-form-field>
                      <!-- <mat-error *ngIf="form.get('mobileOrEmail')?.touched && form.get('mobileOrEmail')?.hasError('required')">Mobile Number required</mat-error> -->
                       <mat-error *ngIf="form.controls['mobileOrEmail'].hasError('pattern') && 
                       (form.controls['mobileOrEmail'].dirty || form.controls['mobileOrEmail'].touched)
                        || (form.controls['mobileOrEmail'].hasError('isMobileInValid'))">
                           Please enter valid email or mobile no.</mat-error> 
                </div>

                                                
                <div *ngIf="sendotp">
                    <p class="f-16 regularfont greyfont">Please enter OTP we have sent on your mobile</p>
                    <ng-otp-input (onInputChange)="onMobileOtpChange($event)"  [config]="config" style="margin: auto;"></ng-otp-input>
                    <mat-error>{{errorMsg}}</mat-error>
                    <div class="d-flex justify-content-end otppos">
                        <p class="f-14 regularfont voilet-text counter" [ngClass]="{'disable-text':disableTimer}">{{this.counter}}</p>
                        <p class="f-14 regularfont voilet-text resendotp" [ngClass]="{'disable-text':disableResend}" (click)="submit()" >Resend OTP</p>
                    </div>
                </div>
            <span class="f-12 greyfont" *ngIf="!isMail">You will receive OTP on this number</span>
            <div *ngIf="isPassword && !sendotp">
                    <p class="f-16 regularfont greyfont">Enter your password</p>
                <mat-form-field class="example-full-width" appearance="outline" class="w100">
                    <input matInput autocomplete="off" formControlName="userPassword"  style="text-align: left;"  type="password">                        
                </mat-form-field>
            </div>
            <div class="info">  
                <div class="col-12 col-md-8">
                    <div class="mt-20 checkbox" [ngClass]="sendotp ? 'displayNone' : 'displayBlock'" style="display: flex;">
                        <mat-checkbox class="example-margin" #confirmed>I agree to the <u (click)="terms()"> terms and conditions</u></mat-checkbox>                
                    </div>
                </div> 
                
                <div *ngIf="!((!confirmed.checked) || !isMail || flag) && (isPassword && !sendotp)" class="col-12 col-md-4 cPointer" style="text-align: right;">
                    <span (click)="forgot_password()">Forgot Password?</span>
                </div>
            </div>
            
            <div class="row text-center login-btn mt-30 mview">
                <div class="col-md-12 btn-style">
                    <div class="col-md-6 pwbtn" style="padding-left: 0;margin-right: 15px;" *ngIf="!sendotp">
                        <button mat-raised-button color="primary" type="button" class="f-18 cPointer" [disabled]="((!confirmed.checked) || !isMail || flag)"  (click)="withPassword()">Login with Password</button>                        
                    </div>
                    <div class="col-md-6" style="padding-left: 0;" *ngIf="!sendotp">
                        <button mat-raised-button color="primary" type="button" (click)="submit()"  class="f-18 cPointer otpbtn" 
                        [disabled]="((!confirmed.checked) || !isMobile
                        || (form.controls['mobileOrEmail'].hasError('isMobileInValid')) || flag)" >Login with OTP</button>                        
                    </div>
                    <div class="col-md-6" style="padding-left: 0; margin-right: 15px;" *ngIf="sendotp">
                        <button mat-raised-button color="primary" class="f-18 cPointer" type="button" (click)="goBack()">Back</button>
                        </div>
                        <div class="col-md-6 resendotp" style="padding-right: 0;" *ngIf="sendotp">    
                            <button mat-raised-button color="primary" type="button" (click)="verify()" class="f-18 cPointer" [disabled]="( !verifyOtp)">Verify OTP</button>                            
                        </div>
                    <!-- <div class="col-md-6 resendotp" style="padding-right: 0;">
                            <button mat-stroked-button color="primary" class="f-18 cPointer" type="button" [disabled]="!form.valid || !verifyOtp">Resend OTP</button>
                    </div> -->
                </div>               
            </div>
        
        </form>   
        </div>
    </div>
</div>
<creditfaircapital-modal id="certificatemodal-regis" class="creditfaircapital-modal-override">
    <div class="text-center cpopup" >
        <div>
            <div class="mt-12 semifont mt-20 f-24 fw-900 ls">Hey there, We've got our P2P license <br> to continue investing with us please click on INVEST NOW!</div>
            <div style="padding-top: 50px; padding-bottom: 50px;">
                <a mat-raised-button  style="margin-right: 19px;" color="primary" href="http://p2p.creditfaircapital.in/" target="_blank">INVEST NOW</a>
                <a mat-raised-button color="primary" (click)="closeModal('certificatemodal-regis')">Log In</a>  
            </div>
            <!-- <div class="mt-12 semifont f-19 fw-900 lh">Your Payment was Unsuccessful. <br/> Please Try Again in sometime</div>
            <div class="mt-20 semifont f-19 fw-900 lh">For any issues, Email us at<br/>info@creditfaircapital.in</div> -->
        </div>
    </div>
</creditfaircapital-modal>
